import axios from 'axios';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/browser';
import { Trans } from 'react-i18next';
import i18n from '../i18n';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

let networkErrorHandler = null;
let loaderErrorActive = false;

export function setNetworkErrorHandler(fn) {
  networkErrorHandler = fn;
}

export function setLoaderErrorActive(active) {
  loaderErrorActive = active;
}

const reloadButton = (
  <button
    onClick={() => window.location.reload()}
    style={{
      background: 'none',
      border: 'none',
      color: 'inherit',
      cursor: 'pointer',
      fontWeight: 'bold',
      padding: 0,
      textDecoration: 'underline',
    }}
  />
);

const NetworkErrorToast = () => (
  <span>
    <Trans i18n={i18n} i18nKey="errors.network" components={{ reload: reloadButton }} />
  </span>
);

axios.interceptors.response.use(null, (error) => {
  // A request made in the background, whose failure the caller handles quietly
  if (error.config?.silent) return Promise.reject(error);

  const isNetworkError = !error.response;
  const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;

  if (isNetworkError) {
    if (networkErrorHandler) {
      networkErrorHandler();
    } else if (!loaderErrorActive) {
      toast.error(NetworkErrorToast, { toastId: 'network-error', autoClose: 10000 });
    }
  } else if (!expectedError) {
    toast.error(i18n.t('errors.unexpected'), { toastId: 'server-error', autoClose: 10000 });

    Sentry.captureException(error, {
      tags: {
        status: error.response?.status,
        url: error.config?.url,
        method: error.config?.method,
      },
    });
  }

  return Promise.reject(error);
});

function setJwt(jwt) {
  axios.defaults.headers.common['x-auth-token'] = jwt;
}

const httpService = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
  setJwt,
};

export default httpService;
